import {Component, effect, inject, Signal} from '@angular/core';
import {IGroupMap, INITIAL_STATE_TOKEN, TableVerticalControlComponent} from 'frontier/index';
import {MatProgressBar} from '@angular/material/progress-bar';
import {ICart} from '../process-overview/service/state.interface';
import {ProcessOverviewStore} from '../process-overview/service/process-overview.store';
import ControlGuids from "../../../api/ControlGuids";
import {
  TableVerticalControlCoreComponent
} from "frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control-core/table-vertical-control-core.component";

@Component({
  selector: 'app-shipping-and-payment',
  standalone: true,
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.scss',
  imports: [MatProgressBar, TableVerticalControlCoreComponent],
  providers: [{provide: INITIAL_STATE_TOKEN, useValue: {filter: null}}],
})
export class ShippingAndPaymentComponent extends TableVerticalControlComponent {
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);

  private _selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;

  override GUID: string = ControlGuids.TClientDebit;

  override groupMap: IGroupMap = {
    'Abrechnungszeitraum': [0, 1],
    'Versandoptionen': [2, 3, 4, 5],
    'Pflegekostenzuschuss': [6, 7, 8],
    'Lastschriftmandat': [9, 10, 11, 12, 13],
  }

  constructor() {
    super();
    effect(() => {
      const selectedCart: ICart = this._selectedCart();
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj
        });
      }
    }, {allowSignalWrites: true});
  }
}
